module.exports = __webpack_public_path__ + "static/media/offlineGreenDining.2ee09d17.svg";